<template>
  <div>
    <Details v-if="isDetails" />
    <Table v-else />
  </div>
</template>

<script>
import Details from "@/components/DataExplorer/Details.vue";
import Table from "@/components/DataExplorer/Table.vue";

export default {
  components: { Table, Details },
  props: {},
  data() {
    return {};
  },
  computed: {
    isDetails: function () {
      return ["projectDataExplorerDetails"].includes(this.$route.name);
    }
  },
  mounted() {},
  methods: {}
};
</script>
